"use client";
import { Block } from "components/Layout";
import PropTypes from "prop-types";

function DefaultErrorMessage({ errorMessage }) {
  return (
    <Block>
      {errorMessage ? (
        <p className="color--red">{errorMessage}</p>
      ) : (
        <p className="color--red">
          Auda, her gikk noe galt. Prøv igjen, eller gi oss et vink på{" "}
          <a href="mailto:hei@whee.no" className="link">
            hei@whee.no
          </a>{" "}
          så hjelper vi deg.
        </p>
      )}
    </Block>
  );
}

DefaultErrorMessage.propTypes = {
  errorMessage: PropTypes.node
};

export default DefaultErrorMessage;
